import React from 'react';
import ReactDOM from 'react-dom';
import { Share } from 'react-facebook';
import FacebookProvider from './FacebookProvider';

class ShareButton extends React.PureComponent {
  props: {
    initProps: {
      shareUrl: string,
      text: string
    }
  };

  render() {
    const { initProps: { shareUrl, text } } = this.props;

    return (
      <FacebookProvider>
        <Share href={shareUrl}>
          <button className="c-button c-button--facebook">
            <span className="c-button__content">
              <span className="text-icon">
                <i className="icon-facebook text-icon__icon" />
                <span className="text-icon__text">{text}</span>
              </span>
            </span>
          </button>
        </Share>
      </FacebookProvider>
    );
  }
}

export const renderInto = (selector, props) => {
  ReactDOM.render(
    <ShareButton initProps={props} />,
    document.querySelector(selector)
  );
};

export default ShareButton;



// WEBPACK FOOTER //
// ./app/Assets/js/features/facebook/ShareButton.js